const React = require('react');

// eslint-disable-next-line import/no-extraneous-dependencies
const moment = require('moment');

var BuildStatus = function(props) {
	if (typeof props.deployment.short_sha === 'undefined' && !props.deployment.package_link) {
		return null;
	}

	let label = null;
	if (props.deployment.ref_name) {
		label = (
			<span>
				<span className="label label-default text-truncate deployment-branch">{props.deployment.ref_name}</span>
			</span>
		);
	}

	let classes = null;
	if (props.status_box) {
		classes = 'status-box default';
	}

	let secondaryLine = null;
	if (props.status_ago) {
		secondaryLine = moment.unix(props.deployment.date_created_unix).fromNow();
	} else {
		secondaryLine = props.deployment.commit_subject;
	}

	let primaryLine = '';
	if (props.deployment.title) {
		primaryLine = props.deployment.title;
	}

	let deploymentDetails = props.deployment.short_sha;
	let deploymentTitle = props.deployment.sha;
	let deploymentClass = 'sha-detail';
	let deploymentLink = props.deployment.commit_url;
	if (props.deployment.package_link) {
		deploymentDetails = 'Compressed package';
		if (props.deployment.title) {
			deploymentDetails = props.deployment.title;
			if (props.deployment.title.length > 20) {
				deploymentDetails = props.deployment.title.substring(0, 25) + '...';
			}

		}
		primaryLine = props.deployment.package_link;
		deploymentTitle = props.deployment.package_link;
		deploymentClass = 'package-detail';
		deploymentLink = props.deployment.package_link;
	}

	let commit = deploymentDetails;
	if (props.commitAsLink) {
		commit = (
			<a
				className={deploymentClass}
				target="_blank"
				rel="noopener noreferrer"
				href={deploymentLink}
				title={deploymentTitle}
			>
				{deploymentDetails}
			</a>
		);
	}

	return (
		<div className={classes}>
			{commit}
			&nbsp;
			{label}
			<small className="env-desc secondary-content text-truncate">{primaryLine} {secondaryLine}</small>
		</div>
	);
};

module.exports = BuildStatus;
